/**
 * Rechte in der Oberfläche.
 *
 * Wichtig: Das hier ist **Bequemlichkeit, keine Sicherheit**. Entschieden wird
 * serverseitig bei jeder Anfrage (`app.requirePermission`). Hier blenden wir
 * nur aus, was ohnehin im „verboten“ endet – damit niemand gegen Knöpfe läuft,
 * die für ihn nicht gedacht sind.
 *
 * Dieselbe Matrix wie im Server, aus @webradiosuite/shared – es gibt keine
 * zweite Wahrheit, die auseinanderlaufen könnte.
 */
import { can, effectivePermissions, type Permission } from "@webradiosuite/shared";
import { useAuth } from "./AuthProvider";

export function usePermission(): {
  darf: (recht: Permission) => boolean;
  rolle: string | undefined;
  alle: ReadonlySet<Permission>;
} {
  const { user } = useAuth();
  const rolle = user?.role;
  return {
    darf: (recht: Permission) => (rolle ? can(rolle, recht) : false),
    rolle,
    alle: rolle ? effectivePermissions(rolle) : new Set<Permission>(),
  };
}

/**
 * Für einzelne Knöpfe. Gibt `null` zurück, wenn das Recht fehlt – dann
 * rendert React nichts.
 */
export function Wenn({
  recht,
  children,
}: {
  recht: Permission;
  children: React.ReactNode;
}): React.ReactNode {
  const { darf } = usePermission();
  return darf(recht) ? children : null;
}
